export const removeHTMLTags = (value: string | undefined): string =>
  value?.replaceAll(/(<([^>]+)>)/gi, '') || ''
